import { render, staticRenderFns } from "./FeedbackDetail.vue?vue&type=template&id=3c26dbea&scoped=true"
import script from "./FeedbackDetail.vue?vue&type=script&lang=js"
export * from "./FeedbackDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c26dbea",
  null
  
)

export default component.exports